(() => {
  const MIN_DELAY_MS = 30000;
  const startedAt = Date.now();
  const root = document.documentElement;

  root.classList.add('luna-newsletter-hold');

  const consentIsVisible = () => {
    const banner = document.querySelector('#shopify-pc__banner');
    if (!banner) return false;

    const style = window.getComputedStyle(banner);
    const rect = banner.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const releaseWhenReady = () => {
    const remaining = MIN_DELAY_MS - (Date.now() - startedAt);

    if (remaining > 0) {
      window.setTimeout(releaseWhenReady, Math.min(remaining, 1000));
      return;
    }

    if (consentIsVisible()) {
      window.setTimeout(releaseWhenReady, 500);
      return;
    }

    root.classList.remove('luna-newsletter-hold');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', releaseWhenReady, { once: true });
  } else {
    releaseWhenReady();
  }
})();
